<template>
    <div class="order">
        <el-drawer
            :title="detailData.title"
            :visible.sync="detailParam.visible"
            size="520px"
            :close-on-press-escape="false"
            :wrapperClosable="false"
        >
            <div class="drawer-wrapper">
                <div class="drawer-main" v-loading="detailData.loading.main">
                    <div class="drawer-body">
                        <div class="drawer-order">
                            <div class="step">
                                <ul class="step-wrapper">
                                    <li class="step-item">
                                        <div class="step-item-main step-item-finish">
                                            <span class="step-item-title">报单</span>
                                        </div>
                                        <template v-if="detailData.row.created_at">
                                            <div class="step-item-description">
                                                {{ detailData.row.order_user.name }} ·
                                                {{ detailData.row.created_at }}
                                            </div>
                                            <div class="step-item-button">
                                                <template v-if="detailData.row.order_status_id <= 2">
                                                    <el-button size="mini" type="primary" @click="StateOrder(3)"
                                                        >取消</el-button
                                                    >
                                                </template>
                                                <template v-if="detailData.row.order_status_id == 4">
                                                    <el-button size="mini" type="primary" @click="StateOrder(41)"
                                                        >退货</el-button
                                                    >
                                                </template>
                                            </div>
                                        </template>
                                    </li>
                                    <li class="step-item">
                                        <div
                                            :class="
                                                detailData.row.deliver_at
                                                    ? 'step-item-main step-item-finish'
                                                    : 'step-item-main'
                                            "
                                        >
                                            <span class="step-item-title">发货</span>
                                        </div>
                                        <template v-if="detailData.row.deliver_at">
                                            <div class="step-item-description">
                                                {{ detailData.row.order_status_user.name }} ·
                                                {{ detailData.row.deliver_at }}
                                            </div>
                                            <template v-if="detailData.row.order_status_id === 4">
                                                <div class="step-item-button">
                                                    <template v-if="detailData.row.order_logistics_info[0].number">
                                                        <el-button size="mini" @click="DetailExpress(detailData.row)"
                                                            >查看物流</el-button
                                                        >
                                                    </template>
                                                    <template
                                                        v-if="
                                                            $store.state.userInfo.identity === 1 ||
                                                                detailData.row.order_status_id === 4
                                                        "
                                                    >
                                                        <el-button size="mini" type="primary" @click="StateOrder(4)"
                                                            >修改</el-button
                                                        >
                                                    </template>
                                                </div>
                                            </template>
                                        </template>
                                    </li>
                                    <li class="step-item">
                                        <div
                                            :class="
                                                detailData.row.order_status_id === 40
                                                    ? 'step-item-main step-item-finish'
                                                    : 'step-item-main'
                                            "
                                        >
                                            <span class="step-item-title">签收</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div class="drawer-body-main">
                                <template
                                    v-if="
                                        $store.state.userInfo.identity === 1 ||
                                            $store.state.userInfo.id === detailData.row.owner_id ||
                                            $store.state.userInfo.id === detailData.row.order_user.id
                                    "
                                >
                                    <el-table
                                        :data="detailData.row.details"
                                        style="width: 100%"
                                        class="el-table__justify"
                                    >
                                        <el-table-column label="产品">
                                            <template slot-scope="scope"
                                                >{{ scope.row.product.name }}（{{
                                                    scope.row.product.barcode
                                                }}）</template
                                            >
                                        </el-table-column>
                                        <el-table-column label="单价" width="90">
                                            <template slot-scope="scope">{{ scope.row.price | $separator }}</template>
                                        </el-table-column>
                                        <el-table-column label="数量" width="90">
                                            <template slot-scope="scope"
                                                >{{ scope.row.num }}{{ scope.row.unit_title }}</template
                                            >
                                        </el-table-column>
                                    </el-table>
                                </template>
                                <template v-else>
                                    <el-table
                                        :data="detailData.row.details"
                                        style="width: 100%"
                                        class="el-table__justify"
                                    >
                                        <el-table-column label="产品">
                                            <template slot-scope="scope"
                                                >{{ scope.row.product.name }}（{{
                                                    scope.row.product.barcode
                                                }}）</template
                                            >
                                        </el-table-column>
                                        <el-table-column label="数量" width="90">
                                            <template slot-scope="scope"
                                                >{{ scope.row.num }}{{ scope.row.unit_title }}</template
                                            >
                                        </el-table-column>
                                    </el-table>
                                </template>
                                <template v-if="detailData.row.memo">
                                    <el-alert :title="detailData.row.memo" type="warning" :closable="false"></el-alert>
                                </template>
                                <div class="drawer-body-aggregation">
                                    <el-row>
                                        <el-col :span="8">发货方式：</el-col>
                                        <el-col :span="16" class="t-right">{{
                                            detailData.row.express_type_id | $express
                                        }}</el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col :span="8">总金额：</el-col>
                                        <el-col :span="16" class="t-right">{{
                                            detailData.row.total | $separator
                                        }}</el-col>
                                    </el-row>
                                    <el-row v-if="detailData.row.compensate">
                                        <el-col :span="8">优惠：</el-col>
                                        <el-col :span="16" class="t-right t-through">{{
                                            detailData.row.compensate | $separator
                                        }}</el-col>
                                    </el-row>
                                    <el-row v-if="detailData.row.freight">
                                        <el-col :span="8">运费：</el-col>
                                        <el-col :span="16" class="t-right">{{
                                            detailData.row.freight | $separator
                                        }}</el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col :span="8">回款方式：</el-col>
                                        <el-col :span="16" class="t-right">
                                            {{ detailData.row.pay_id | $pay }}
                                            <!-- 是否对账0未对账  1已对账 -->
                                            <template v-if="!detailData.row.is_econciliation">
                                                 丨 
                                                <template v-if="detailData.row.should <= 1000"">
                                                    <el-popover placement="top" width="186" trigger="hover">
                                                        <canvas id="qrcode" style="width: 160px; height: 160px"></canvas>
                                                        <strong slot="reference">支付</strong>
                                                    </el-popover>
                                                </template>
                                                <template v-else>
                                                    <el-tooltip effect="dark" content="千元以上，手动转账" placement="top">
                                                        <strong>支付</strong>
                                                    </el-tooltip>
                                                </template>
                                            </template>
                                            <!-- <template v-if="!detailData.row.is_econciliation && detailData.row.should"
                                                >丨
                                                <el-link
                                                    type="primary"
                                                    :href="detailData.pay"
                                                    target="_blank"
                                                    :underline="false"
                                                    >支付宝支付</el-link
                                                ></template
                                            > -->
                                            <template v-if="detailData.record.length"
                                                >丨<el-popover placement="top" width="240" trigger="hover">
                                                    <div>
                                                        <p :key="index" v-for="(row, index) in detailData.record">
                                                            {{ (row.amount / 100) | $separator }} /
                                                            {{ $moment(row.create_at).format('YYYY-MM-DD HH:mm:ss') }}
                                                        </p>
                                                    </div>
                                                    <strong slot="reference">明细</strong>
                                                </el-popover>
                                            </template>
                                        </el-col>
                                    </el-row>
                                    <el-row v-if="detailData.row.third_id">
                                        <el-col :span="8">第三方订单号</el-col>
                                        <el-col :span="16" class="t-right">{{ detailData.row.third_id }}</el-col>
                                    </el-row>
                                    <template v-if="$store.state.userInfo.identity === 1">
                                        <el-row>
                                            <el-col :span="8">销售回款：</el-col>
                                            <el-col :span="16" class="t-right t-danger t-large">{{
                                                detailData.row.should | $separator
                                            }}</el-col>
                                        </el-row>
                                        <el-row v-if="detailData.row.actually">
                                            <el-col :span="8">实际到账（财务）：</el-col>
                                            <el-col :span="16" class="t-right">{{
                                                detailData.row.actually | $separator
                                            }}</el-col>
                                        </el-row>
                                    </template>
                                </div>
                            </div>
                            <template v-if="$store.state.userInfo.identity === 1">
                                <el-divider></el-divider>
                                <el-row>
                                    <el-col :span="6">
                                        <el-button
                                            size="small"
                                            :disabled="
                                                detailData.row.is_econciliation == 1 ||
                                                    detailData.row.order_status_id === 3 ||
                                                    detailData.row.order_status_id === 30 ||
                                                    detailData.row.order_status_id === 41 ||
                                                    detailData.row.order_status_id === 410
                                            "
                                            @click="ReconciliationOrder(detailData.row)"
                                            >对账</el-button
                                        >
                                    </el-col>
                                    <el-col :span="$store.state.userInfo.identity === 1 ? 18 : 24" class="t-right">
                                        <template v-if="detailData.row.order_status_id === 3">
                                            <el-button-group>
                                                <el-button size="small" @click="StateOrder(1)">拒绝</el-button>
                                                <el-button size="small" @click="StateOrder(30)">同意</el-button>
                                            </el-button-group>
                                        </template>
                                        <template v-if="detailData.row.order_status_id === 41">
                                            <el-button-group>
                                                <el-button size="small" @click="StateOrder(40)">拒绝</el-button>
                                                <el-button size="small" @click="StateOrder(410)">同意</el-button>
                                            </el-button-group>
                                        </template>
                                        <template v-if="detailData.row.order_status_id === 1">
                                            <el-button size="small" @click="StateOrder(2)">备货</el-button>
                                        </template>
                                        <template
                                            v-if="
                                                detailData.row.order_status_id <= 3 ||
                                                    detailData.row.order_status_id === 30
                                            "
                                        >
                                            <el-button size="small" type="primary" @click="StateOrder(4)"
                                                >发货</el-button
                                            >
                                        </template>
                                    </el-col>
                                </el-row>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </el-drawer>

        <v-OrderDeliver :detailParam="componentParam.orderDeliver" v-if="componentParam.orderDeliver.visible" />
        <!-- 物流记录 -->
        <v-OrderExpress :detailParam="componentParam.orderExpress" v-if="componentParam.orderExpress.visible" />
    </div>
</template>

<script>
import QRCode from 'qrcode'
import orderDeliver from '@/components/order/Deliver'
import OrderExpress from '@/components/order/Express'
export default {
    components: {
        'v-OrderDeliver': orderDeliver,
        'v-OrderExpress': OrderExpress
    },
    inject: ['reload'],
    props: ['detailParam'],
    data() {
        return {
            productData: {
                list: [],
                pages: {
                    page: 1,
                    pagesize: 9999
                }
            },
            detailData: {
                loading: {
                    main: false,
                    submit: false
                },
                title: '订单详情',
                status: null,
                row: {
                    details: null,
                    customer: {},
                    order_user: {}
                },
                record: [],
                pay: ''
            },
            componentParam: {
                orderDeliver: {},
                orderExpress: {}
            }
        }
    },
    created() {
        this.$nextTick(() => {})
    },
    mounted() {
        this.$nextTick(() => {
            if (this.detailParam.row.id) {
                this.GetOrder()
                // 获取支付记录
                this.GetPayRecord()
            }
        })
    },
    methods: {
        GetOrder() {
            this.detailData.loading.main = true
            this.$request({
                url: '/api/v1/order/' + this.detailParam.row.id
            }).then(res => {
                if (!res.status) {
                    this.detailData.loading.main = false
                    this.detailData.title = res.data.order_no
                    this.detailData.row = res.data

                    setTimeout(() => {
                        this.GetQrcode(res.data.id)
                    })
                } else {
                    this.$message.error(res.message || '操作失败')
                }
            })
        },
        GetPayRecord() {
            this.$request({
                url: 'https://pay.hemutx.com/payment/record',
                params: {
                    order_id: this.detailParam.row.id
                }
            }).then(res => {
                if (!res.status) {
                    this.detailData.record = res.data
                }
            })
        },
        // 获取付款码
        GetQrcode(id) {
            const qrcode = document.getElementById('qrcode')
            let url = ''
            this.$request({
                url: 'https://pay.hemutx.com/payment/total',
                params: {
                    // 收款账户（1 => 和牧通联账户，2 => 和牧微信商户号，3 => 秉牧微信商户号）
                    account_id: 3
                }
            }).then(res => {
                if (!res.status) {
                    // 秉牧账户每月支付10000元
                    if (res.data.total > 1000000) {
                        // 通联支付活码
                        url = 'https://admin.hemutx.com/pay?order_id=' + id
                    } else {
                        // 微信支付活码
                        url =
                            'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
                            this.$store.state.appid +
                            '&redirect_uri=https://admin.hemutx.com/pay?order_id=' +
                            id +
                            '&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect'
                    }
                    QRCode.toCanvas(
                        qrcode,
                        url,
                        { width: 160 },
                        error => {
                            if (error) console.error(error)
                        },
                        200
                    )
                }
            })
        },
        // 物流
        DetailExpress(row) {
            this.componentParam.orderExpress = {
                visible: true,
                row: {
                    express_number: row.order_logistics_info[0].number
                }
            }
        },
        // 企业对账
        ReconciliationOrder(row) {
            this.$confirm('收到当前订单款, 确定继续吗？', '警告', {
                confirmButtonText: '确 定',
                cancelButtonText: '取 消'
            })
                .then(() => {
                    this.$request({
                        url: '/api/v1/reconciliation',
                        params: {
                            order_id: [row.id]
                        }
                    }).then(res => {
                        if (!res.status) {
                            this.$message({
                                message: res.message || (res.status ? '操作失败' : '操作成功'),
                                type: res.status ? 'error' : 'success'
                            })
                            if (!res.status) {
                                this.detailParam.visible = false
                                this.$parent.GetOrder()
                            }
                        }
                    })
                })
                .catch(() => {})
        },
        StateOrder(status) {
            switch (status) {
                case 3 || 41:
                    this.$prompt(null, '原因', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消'
                    })
                        .then(({ value }) => {
                            this.StateOrderFn(this.detailData.row.id, status, value)
                        })
                        .catch(() => {})
                    break
                case 4:
                    this.componentParam.orderDeliver = {
                        visible: true,
                        row: {
                            id: this.detailData.row.id
                        }
                    }
                    break
                default:
                    this.$confirm('修改订单状态, 确定继续吗？', '警告', {
                        confirmButtonText: '确 定',
                        cancelButtonText: '取 消'
                    })
                        .then(() => {
                            this.StateOrderFn(this.detailData.row.id, status)
                        })
                        .catch(() => {})
                    break
            }
        },
        StateOrderFn(id, status, reason) {
            this.$request({
                url: '/api/v1/order_status',
                params: {
                    id: id,
                    deliver_type_id: status === 30 ? 1 : null,
                    status: status,
                    cancel_reason: reason || null
                }
            }).then(res => {
                this.$message({
                    message: res.message || (res.status ? '操作失败' : '操作成功'),
                    type: res.status ? 'error' : 'success'
                })
                if (!res.status) {
                    this.detailParam.visible = false
                    this.$parent.GetOrder()
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
@import '~@/assets/css/drawer.less';
@import '~@/assets/css/step.less';
</style>
